import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { goldColors, goldMedalLarge } from "@ssf/components";
import { useTranslation } from "react-i18next";

const SESSION_KEY = "goldCongratsShown";

export const GoldCongratsDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation("GoldCongratsDialog");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: goldColors.surface,
          color: goldColors.text,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          fontFamily: '"Montserrat", sans-serif',
          fontWeight: 800,
        }}
      >
        <Box component="img" src={goldMedalLarge} alt="" sx={{ height: 48 }} />
        {t("title")}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>{t("message")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const shouldShowGoldCongrats = (enabled: boolean) => {
  if (!enabled) return false;
  const shown = localStorage.getItem(SESSION_KEY);
  if (shown) return false;
  localStorage.setItem(SESSION_KEY, "1");
  return true;
};
